import axiosInstance from "./AxiosInstance";

export function getSymptomMedicineMappings(pagination, pageid,search_by = "", search_keyword = "" ) {
  return axiosInstance.post("/admin/symptomMedicine", { pagination, pageid , search_by, search_keyword,});
}

export function createSymptomMedicineMapping(mappingData) {
  return axiosInstance.post("/admin/symptomMedicineAdd", mappingData);
}

export function updateSymptomMedicineMapping(mappingData) {
  return axiosInstance.post("/admin/editMapping", mappingData);
}

export function deleteSymptomMedicineMapping(mapping) {
  return axiosInstance.post("/admin/deleteMapping", mapping);
}

export function formatSymptomMedicineMappings(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((m) => ({
      ...m,
      symptom_medicine_id: m.symptom_medicine_id || m._id || m.id,
    }));
  }

  return Object.entries(responseData).map(([key, m]) => ({
    ...m,
    symptom_medicine_id: m.symptom_medicine_id || m._id || m.id || key,
  }));
}